import { Mail, User2, Mails } from 'lucide-react';
import S0 from '../assets/images/San Jose State University.jpg'
import S3 from '../assets/images/Logo_HCM-UTE.png'
// import Arun from '../assets/images/vice_chancellor_img.jpg'
// import Alex from '../assets/images/Alex Stojcevski.jpg'
import CurtinLogo from '../assets/images/Curtin Singapore logo - keyline.jpg'
import APAQA from '../assets/images/APAQA_Logo.png'

function About() {
    return (
        <div>
            <h2>Contact Us</h2>
            <p>Please direct any submission related inquiries to:</p>
            <p><User2></User2>Professor Dr Arun Patil, Curtin University Singapore</p>
            <p><Mail></Mail><a href="mailto:arun.patil@curtin.edu.sg" target='_blank' rel="noreferrer noopener">arun.patil@curtin.edu.sg</a></p>
            <p>OR</p>
            <p><User2></User2>Assoc. Prof. Dr. Nguyen Minh Ly, The University of Da Nang - University of Science and Education</p>
            <p><Mail></Mail><a href="mailto:Minhlyvn24@gmail.com" target='_blank' rel="noreferrer noopener">Minhlyvn24@gmail.com</a>, <a href="mailto:nmly@ued.udn.vn" target='_blank' rel="noreferrer noopener">nmly@ued.udn.vn</a></p>
            <p><Mails></Mails>For any other queries: <a href="mailto:contact@ietbhec.com" target='_blank' rel="noreferrer noopener">contact@ietbhec.com</a></p>

            <section className="sponsor-strip">
                <h4>Proudly supported by</h4>

                <div className="sponsor-strip-logos">
                    <img src={S0} alt="" />
                    <img src={S3} alt="" />
                    <img src={CurtinLogo} alt="" />
                    <img src={APAQA} alt="" />
                </div>
            </section>
        </div>
    )
}

export default About